import script from "./OfflineModeIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./OfflineModeIndicator.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__